import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { bankIdPaymentReportCompleted, bankIdPaymentReportUpdated } from "store/actions/bankIdPaymentsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { BankIdPaymentsFooterProps } from "models/propTypes/paymentPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageFooter, useBankIdSignDialog } from "components/common";
import { usePaymentService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, PaymentHelper } from "utils/helpers";

const BankIdPaymentsFooter: React.FC<BankIdPaymentsFooterProps> = (props) => {
  const paymentService = usePaymentService();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { selectedPayments, reloadHandler, disableSuccessMessages } = props;

  const signBankIdPayments = () => {
    const paymentsToSign = {
      incomingInvoiceIds: selectedPayments.incomingInvoices?.map((p) => p.id),
      receiptIds: selectedPayments.receipts?.map((p) => p.id),
      salaryPayoutIds: selectedPayments.salaryPayoutFileRows?.map((p) => p.id),
      manualPayoutIds: selectedPayments.manualPayouts?.map((p) => p.id),
      personSalaryEntryIds: selectedPayments.personSalaryEntries?.map((p) => p.id),
      wintSalaryEntryIds: selectedPayments.wintSalaryEntries?.map((p) => p.id),
    } as WintSuperkollAPIModel.SignPaymentsPost;

    return paymentService.signBankIdPayments(paymentsToSign);
  };

  const onBankIdSignAcceptSuccess = () => {
    reloadHandler((item) => {
      if (item && PaymentHelper.calculateBankIdTotal(item) !== 0) {
        dispatch(bankIdPaymentReportUpdated(item));
      } else {
        dispatch(bankIdPaymentReportCompleted(0));
      }
    });
  };

  const bankIdSignDialog = useBankIdSignDialog(
    {
      getSignKeyHandler: signBankIdPayments,
      successMessage: TranslationKeys.Payments.PaymentsSignedSuccessMessage,
    },
    onBankIdSignAcceptSuccess
  );

  const onPaymentsAcceptClick = async () => {
    dispatch(displayDialog(bankIdSignDialog));
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Sign)}${
            props.selectedPaymentsCount > 0 ? ` (${props.selectedPaymentsCount})` : ""
          }`,
          onClick: onPaymentsAcceptClick,
          type: StyleEnums.DisplayType.Success,
          isDisabled: props.selectedPaymentsCount === 0,
        },
      ]}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default BankIdPaymentsFooter;
